import React, { Component } from "react";
import "../block-download/block_download.css";
import { Link } from "react-router-dom";
import {
    ToastsStore,
    ToastsContainer,
    ToastsContainerPosition,
} from "react-toasts";
import moment from "moment";
import { hasPageAccess } from "../../utils/pagePermissionService";
import { callApi } from "../../utils/api";



declare var $: any;
interface AllProps {
    history: any;
}
class VettingAutoMailManagement extends Component<AllProps> {
    state = {
        activeTab: "bank_branch" as "bank_branch" | "lh_branch",
        Categorybank: [],
        filteredBanks: [],
        branchList: [] as any[],
        filteredBranchList: [] as any[],
        outreason: "",
        selectVal: false,
        isLoading: false,
        isSavingBank: false,
        isSavingBranch: false,
        searchTerm: "",
        branchSearchTerm: "",
    };

    async componentDidMount() {
        this.getBank();
        this.getBranch();
        this.getOutTime();
        const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
        if (!hasHide) {
            this.ouTime();
        }
    }

    filterBanksBySearch = (banks: any[], searchTerm: string) => {
        if (!searchTerm.trim()) return banks;
        const term = searchTerm.toLowerCase();
        return banks.filter((bank: any) => {
            const bankName = bank.bank_name?.toLowerCase() || '';
            const productName = bank.product_name?.toLowerCase() || '';
            const branchName = bank.lh_branch_name?.toLowerCase() || '';
            const combinedName = `${bank.bank_name || ''} (${bank.product_name || ''})`.toLowerCase();
            return bankName.includes(term) || productName.includes(term) || branchName.includes(term) || combinedName.includes(term);
        });
    };

    filterBranchesBySearch = (branches: any[], searchTerm: string) => {
        if (!searchTerm.trim()) return branches;
        const term = searchTerm.toLowerCase();
        return branches.filter((branch: any) => {
            const name = (branch.name || branch.lh_branch_name || "").toLowerCase();
            return name.includes(term);
        });
    };

    getBank() {
        callApi("GET", "vetting_bank_branch_get_management.php")
            .then((res) => res.data)
            .then((result) => {
                const data = result.data || [];
                const searchTerm = this.state.searchTerm || "";
                const filteredBanks = this.filterBanksBySearch(data, searchTerm);
                this.setState({ 
                    Categorybank: data,
                    filteredBanks 
                });
            })
            .catch((err) => {
                console.log(err);
            });
    }

    getBranch() {
        callApi("GET", "get_branch.php")
            .then((res) => res.data)
            .then((result: any) => {
                const data = result?.data ?? (Array.isArray(result) ? result : []);
                const list = Array.isArray(data) ? data : [];
                const branchSearchTerm = this.state.branchSearchTerm || "";
                const filteredBranchList = this.filterBranchesBySearch(list, branchSearchTerm);
                this.setState({ 
                    branchList: list,
                    filteredBranchList 
                });
            })
            .catch((err) => {
                console.log(err);
            });
    }

    handleSearch = (event: any) => {
        const searchTerm = event.target.value;
        const filteredBanks = this.filterBanksBySearch(this.state.Categorybank, searchTerm);
        this.setState({ searchTerm, filteredBanks });
    };

    handleChangetable(event, emp) {
        const { name, checked } = event.target;
        let updatedbank;
        
        // Update main Categorybank array
        if (name === "vetting_pdf") {
            updatedbank = this.state.Categorybank.map((item: any) =>
                item.id === emp.id
                    ? { ...item, vetting_pdf: checked ? 1 : 0 }
                    : item
            );
        } else if (name === "vetting_doc") {
            updatedbank = this.state.Categorybank.map((item: any) =>
                item.id === emp.id
                    ? { ...item, vetting_doc: checked ? 1 : 0 }
                    : item
            );
        } else if (name === "vetting_autoMail") {
            updatedbank = this.state.Categorybank.map((item: any) =>
                item.id === emp.id
                    ? { ...item, vetting_autoMail: checked ? 1 : 0 }
                    : item
            );
        } else if (name === "vetting_preliminaryPDF") {
            updatedbank = this.state.Categorybank.map((item: any) =>
                item.id === emp.id
                    ? { ...item, vetting_preliminaryPDF: checked ? 1 : 0 }
                    : item
            );
        }
        
        // Update filtered banks as well to reflect changes in search results
        const updatedFilteredBanks = this.state.filteredBanks.map((item: any) =>
            item.id === emp.id ? updatedbank.find((b: any) => b.id === emp.id) : item
        );
        
        this.setState({ 
            Categorybank: updatedbank,
            filteredBanks: updatedFilteredBanks 
        });
    }

    handleSubmit = () => {
        const checkedbank = this.state.Categorybank;
        this.setState({ isSavingBank: true });
        callApi("POST", "vetting_auto_mail_bank_branch_update.php", {
            data: checkedbank,
        })
            .then((res) => res.data)
            .then((response) => {
                if (response.success === true) {
                    ToastsStore.success(response.message);
                }
                this.setState({ isSavingBank: false });
            })
            .catch((err) => {
                console.log(err);
                this.setState({ isSavingBank: false });
            });
    };

    clearSearch = () => {
        this.setState({
            searchTerm: "",
            filteredBanks: this.state.Categorybank
        });
    };

    handleBranchSearch = (event: any) => {
        const branchSearchTerm = event.target.value;
        const filteredBranchList = this.filterBranchesBySearch(this.state.branchList, branchSearchTerm);
        this.setState({ branchSearchTerm, filteredBranchList });
    };

    clearBranchSearch = () => {
        this.setState({
            branchSearchTerm: "",
            filteredBranchList: this.state.branchList
        });
    };

    handleTabChange = (tab: "bank_branch" | "lh_branch") => {
        this.setState({ activeTab: tab });
        this.getBank();
        this.getBranch();
    };

    handleBranchTableChange(event: any, branch: any) {
        const { name, checked } = event.target;
        let updatedList;
        if (name === "vetting_pdf") {
            updatedList = this.state.branchList.map((item: any) =>
                item.id === branch.id ? { ...item, vetting_pdf: checked ? 1 : 0 } : item
            );
        } else if (name === "vetting_doc") {
            updatedList = this.state.branchList.map((item: any) =>
                item.id === branch.id ? { ...item, vetting_doc: checked ? 1 : 0 } : item
            );
        } else if (name === "vetting_autoMail") {
            updatedList = this.state.branchList.map((item: any) =>
                item.id === branch.id ? { ...item, vetting_autoMail: checked ? 1 : 0 } : item
            );
        } else if (name === "vetting_preliminaryPDF") {
            updatedList = this.state.branchList.map((item: any) =>
                item.id === branch.id ? { ...item, vetting_preliminaryPDF: checked ? 1 : 0 } : item
            );
        } else {
            return;
        }
        const updatedFiltered = this.state.filteredBranchList.map((item: any) =>
            item.id === branch.id ? updatedList.find((b: any) => b.id === branch.id) : item
        );
        this.setState({ branchList: updatedList, filteredBranchList: updatedFiltered });
    }

    handleBranchSubmit = () => {
        const data = this.state.branchList;
        this.setState({ isSavingBranch: true });
        callApi("POST", "vetting_branch_auto_mail_update.php", { data })
            .then((res) => res.data)
            .then((response: any) => {
                if (response.success === true) {
                    ToastsStore.success(response.message || "LH Branch settings saved successfully.");
                }
                this.setState({ isSavingBranch: false });
            })
            .catch((err) => {
                console.log(err);
                ToastsStore.error("Failed to save LH Branch settings.");
                this.setState({ isSavingBranch: false });
            });
    };

    previousPop = () => {
        $("#out_reason").modal("show");
        $("#another-reason").modal("hide");
    };
    
    BacktoFile = () => {
        $("#out_reason").modal("hide");
        const fileid1: any = localStorage.getItem("currentfileId");
        this.props.history.push("/file-dashboard/" + JSON.parse(fileid1));
    };
    
    getOutTime = () => {
        let date = new Date();
        let stratTime = date.getTime();
        localStorage.setItem("startTime", JSON.stringify(stratTime));
        let outDate = date.toLocaleDateString();
        localStorage.setItem("OutDateGet", JSON.stringify(outDate));
        var Railway = date.getMinutes();
        if (Railway < 10) {
            var TotalMinutes = "0" + Railway;
            let ouTtime = date.getHours() + ":" + TotalMinutes;
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        } else {
            let ouTtime: any = date.getHours() + ":" + date.getMinutes();
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }
    };
    
    ouTime = () => {
        const getfileId: any = localStorage.getItem("currentfileId");
        if (localStorage.getItem("currentfileId")) {
            $("#out_reason").modal("show");
        }
    };
    
    outimeGet = () => {
        this.setState({ isLoading: true });
        const fileid1: any = localStorage.getItem("currentfileId");
        const userid1: any = localStorage.getItem("user1");
        const inreason: any = localStorage.getItem("in_reason");
        const intime: any = localStorage.getItem("IntimeGet");
        const outtime: any = localStorage.getItem("outtimeGet");
        const outdate: any = localStorage.getItem("OutDateGet");
        const secondsSpent = moment(outtime, "HH:mm").diff(
            moment(intime, "HH:mm"),
            "seconds"
        );
        const insertId: any = localStorage.getItem("ProcessEodInsertID");
        if (this.state.outreason == "") {
            this.setState({ selectVal: true, isLoading: false });
        } else {
            let obj = {
                file_id: JSON.parse(fileid1),
                user_id: JSON.parse(userid1),
                in_reason: JSON.parse(inreason),
                out_reason: this.state.outreason,
                intime: JSON.parse(intime),
                outtime: JSON.parse(outtime),
                insert_date: JSON.parse(outdate),
                total_seconds: secondsSpent,
                "insert_id": insertId
            };

            callApi("POST", "process_eod_insert.php", obj)
                .then((res) => res.data)
                .then((response) => {
                    this.setState({ isLoading: false });
                    localStorage.removeItem("in_reason");
                    localStorage.removeItem("outreason");
                    localStorage.removeItem("IntimeGet");
                    localStorage.removeItem("OutDateGet");
                    $("#out_reason").modal("hide");
                    $("#another-reason").modal("hide");
                    ToastsStore.success("Your Reason Saved Successfully");
                    let process_officerId: any =
                        localStorage.getItem("process_office_id");
                    let process_officer_id = JSON.parse(process_officerId);
                    const userid1: any = localStorage.getItem("user1");
                    let user_id = JSON.parse(userid1);
                    const take_file: any = localStorage.getItem("takenfile_id");
                    const user: any = localStorage.getItem("user");
                    const getfileId: any = localStorage.getItem("currentfileId");
                    if (
                        process_officer_id == user_id &&
                        take_file != "" &&
                        take_file == getfileId
                    ) {
                        this.fileout(fileid1);
                    } else {
                        localStorage.removeItem("currentfileId");
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({ isLoading: false });
                    ToastsStore.error("Your Reason Not Stored");
                });
        }
    };
    
    fileout = (fileid1) => {
        let fileId = JSON.parse(fileid1);
        const loginuser: any = localStorage.getItem("user1");
        let req = {
            id: fileId,
            reason: "File Out",
            created_by: JSON.parse(loginuser),
        };
        callApi("POST", "time_update.php", req)
            .then((res) => res.data)
            .then((response) => {
                localStorage.removeItem("currentfileId");
            });
    };
    
    onchangeReason = (e: any) => {
        if (e.target.value == "Other") {
            this.setState({ outreason: "", selectVal: false });
            $("#out_reason").modal("hide");
            $("#another-reason").modal("show");
        } else if (e.target.value == "select") {
            this.setState({ selectVal: false });
        } else {
            this.setState({ outreason: e.target.value, selectVal: false });
        }
    };

    onchange = (e: any) => {
        this.setState({
            outreason: e.target.value.replace(/\s+/g, " ").trim(),
            selectVal: false,
        });
    };
    
    render() {
        const { filteredBanks, searchTerm } = this.state;

        return (
            <section className="pcoded-main-container">
                <ToastsContainer
                    store={ToastsStore}
                    position={ToastsContainerPosition.TOP_RIGHT}
                />
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            <div className="main-body">
                                <div className="page-wrapper">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5>Vetting Auto Mail Management</h5>
                                                    <button
                                                        className="btn btn-primary m-auto"
                                                        style={{ float: "right" }}
                                                        onClick={() => this.props.history.goBack()}
                                                    >
                                                        Back
                                                    </button>
                                                </div>
                                                <div className="card-body">
                                                    <ul className="nav nav-tabs" role="tablist">
                                                        <li className="nav-item">
                                                            <button
                                                                type="button"
                                                                className={`nav-link ${this.state.activeTab === "bank_branch" ? "active" : ""}`}
                                                                onClick={() => this.handleTabChange("bank_branch")}
                                                            >
                                                                Bank Name + LH Branch Name
                                                            </button>
                                                        </li>
                                                        <li className="nav-item">
                                                            <button
                                                                type="button"
                                                                className={`nav-link ${this.state.activeTab === "lh_branch" ? "active" : ""}`}
                                                                onClick={() => this.handleTabChange("lh_branch")}
                                                            >
                                                                LH Branch
                                                            </button>
                                                        </li>
                                                    </ul>

                                                    <div className="tab-content mt-3">
                                                        {/* Tab 1: Bank Name + LH Branch Name */}
                                                        <div className={`tab-pane ${this.state.activeTab === "bank_branch" ? "active" : ""}`}>
                                                            <div className="row mb-3 justify-content-between align-items-center">
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="input-group">
                                                                        <div className="input-group-prepend">
                                                                            <span className="input-group-text"><i className="fa fa-search"></i></span>
                                                                        </div>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Search by Bank Name, Product or Branch..."
                                                                            value={searchTerm}
                                                                            onChange={this.handleSearch}
                                                                        />
                                                                        {searchTerm && (
                                                                            <div className="input-group-append" style={{ marginLeft: "8px" }}>
                                                                                <button className="btn btn-outline-secondary" type="button" onClick={this.clearSearch}>
                                                                                    <i className="fa fa-times"></i> Clear
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="col-auto">
                                                                    <button type="button" className="btn btn-success" onClick={this.handleSubmit} disabled={this.state.isSavingBank}>
                                                                        {this.state.isSavingBank ? <><i className="fa fa-spinner fa-spin"></i> Saving...</> : "Save"}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="table-responsive">
                                                                <form>
                                                                    <div className="sticky-table-container" style={{ height: "70vh" }}>
                                                                        <table className="table table-bordered table-hover">
                                                                            <thead className="sticky-table-header">
                                                                                <tr>
                                                                                    <th scope="col" style={{ width: "60px" }}>Sl.No</th>
                                                                                    <th scope="col">Bank Name</th>
                                                                                    <th scope="col">LH Branch Name</th>
                                                                                    <th scope="col">Branch Name</th>
                                                                                    <th scope="col" style={{ width: "100px", textAlign: "center" }}>Auto Mail</th>
                                                                                    <th scope="col" style={{ width: "80px", textAlign: "center" }}>PDF</th>
                                                                                    <th scope="col" style={{ width: "80px", textAlign: "center" }}>DOC</th>
                                                                                    {/* <th scope="col" style={{ width: "120px", textAlign: "center" }}>Preliminary PDF</th> */}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {filteredBanks.length > 0 ? (
                                                                                    filteredBanks.map((bank: any, index) => (
                                                                                        <tr className="pointer" key={bank.id}>
                                                                                            <td className="indexInput text-center">{index + 1}</td>
                                                                                            <td className="indexInput">{bank.bank_name} ({bank.product_name})</td>
                                                                                            <td className="indexInput">{bank.lh_branch_name}</td>
                                                                                            <td className="indexInput">{bank.name}</td>
                                                                                            <td className="table-body-align text-center">
                                                                                                <input type="checkbox" className="form-control" style={{ width: "20px", height: "20px", margin: "0 auto" }} name="vetting_autoMail" checked={bank.vetting_autoMail == "1"} onChange={(e) => this.handleChangetable(e, bank)} />
                                                                                            </td>
                                                                                            <td className="table-body-align text-center">
                                                                                                <input type="checkbox" className="form-control" style={{ width: "20px", height: "20px", margin: "0 auto" }} name="vetting_pdf" checked={bank.vetting_pdf == "1"} onChange={(e) => this.handleChangetable(e, bank)} />
                                                                                            </td>
                                                                                            <td className="table-body-align text-center">
                                                                                                <input type="checkbox" className="form-control" style={{ width: "20px", height: "20px", margin: "0 auto" }} name="vetting_doc" checked={bank.vetting_doc == "1"} onChange={(e) => this.handleChangetable(e, bank)} />
                                                                                            </td>
                                                                                            {/* <td className="table-body-align text-center">
                                                                                                <input type="checkbox" className="form-control" style={{ width: "20px", height: "20px", margin: "0 auto" }} name="vetting_preliminaryPDF" checked={bank.vetting_preliminaryPDF == "1"} onChange={(e) => this.handleChangetable(e, bank)} />
                                                                                            </td> */}
                                                                                        </tr>
                                                                                    ))
                                                                                ) : (
                                                                                    <tr>
                                                                                        <td colSpan={7} className="text-center" style={{ padding: "30px" }}>
                                                                                            <i className="fa fa-search" style={{ fontSize: "24px", color: "#ccc", marginBottom: "10px" }}></i>
                                                                                            <p>No records found</p>
                                                                                        </td>
                                                                                    </tr>
                                                                                )}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>

                                                        {/* Tab 2: LH Branch */}
                                                        <div className={`tab-pane ${this.state.activeTab === "lh_branch" ? "active" : ""}`}>
                                                            <div className="row mb-3 justify-content-between align-items-center">
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="input-group">
                                                                        <div className="input-group-prepend">
                                                                            <span className="input-group-text"><i className="fa fa-search"></i></span>
                                                                        </div>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Search by LH Branch Name..."
                                                                            value={this.state.branchSearchTerm}
                                                                            onChange={this.handleBranchSearch}
                                                                        />
                                                                        {this.state.branchSearchTerm && (
                                                                            <div className="input-group-append" style={{ marginLeft: "8px" }}>
                                                                                <button className="btn btn-outline-secondary" type="button" onClick={this.clearBranchSearch}>
                                                                                    <i className="fa fa-times"></i> Clear
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="col-auto">
                                                                    <button type="button" className="btn btn-success" onClick={this.handleBranchSubmit} disabled={this.state.isSavingBranch}>
                                                                        {this.state.isSavingBranch ? <><i className="fa fa-spinner fa-spin"></i> Saving...</> : "Save"}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="table-responsive">
                                                                <div className="sticky-table-container" style={{ height: "70vh" }}>
                                                                    <table className="table table-bordered table-hover">
                                                                        <thead className="sticky-table-header">
                                                                            <tr>
                                                                                <th scope="col" style={{ width: "60px" }}>Sl.No</th>
                                                                                <th scope="col">LH Branch Name</th>
                                                                                <th scope="col" style={{ width: "100px", textAlign: "center" }}>Auto Mail</th>
                                                                                <th scope="col" style={{ width: "80px", textAlign: "center" }}>PDF</th>
                                                                                <th scope="col" style={{ width: "80px", textAlign: "center" }}>DOC</th>
                                                                                {/* <th scope="col" style={{ width: "120px", textAlign: "center" }}>Preliminary PDF</th> */}
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {this.state.filteredBranchList.length > 0 ? (
                                                                                this.state.filteredBranchList.map((branch: any, index: number) => (
                                                                                    <tr className="pointer" key={branch.id}>
                                                                                        <td className="indexInput text-center">{index + 1}</td>
                                                                                        <td className="indexInput">{branch.name || branch.lh_branch_name || ""}</td>
                                                                                        <td className="table-body-align text-center">
                                                                                            <input type="checkbox" className="form-control" style={{ width: "20px", height: "20px", margin: "0 auto" }} name="vetting_autoMail" checked={branch.vetting_autoMail == "1" || branch.vetting_autoMail === 1} onChange={(e) => this.handleBranchTableChange(e, branch)} />
                                                                                        </td>
                                                                                        <td className="table-body-align text-center">
                                                                                            <input type="checkbox" className="form-control" style={{ width: "20px", height: "20px", margin: "0 auto" }} name="vetting_pdf" checked={branch.vetting_pdf == "1" || branch.vetting_pdf === 1} onChange={(e) => this.handleBranchTableChange(e, branch)} />
                                                                                        </td>
                                                                                        <td className="table-body-align text-center">
                                                                                            <input type="checkbox" className="form-control" style={{ width: "20px", height: "20px", margin: "0 auto" }} name="vetting_doc" checked={branch.vetting_doc == "1" || branch.vetting_doc === 1} onChange={(e) => this.handleBranchTableChange(e, branch)} />
                                                                                        </td>
                                                                                        {/* <td className="table-body-align text-center">
                                                                                            <input type="checkbox" className="form-control" style={{ width: "20px", height: "20px", margin: "0 auto" }} name="vetting_preliminaryPDF" checked={branch.vetting_preliminaryPDF == "1" || branch.vetting_preliminaryPDF === 1} onChange={(e) => this.handleBranchTableChange(e, branch)} />
                                                                                        </td> */}
                                                                                    </tr>
                                                                                ))
                                                                            ) : (
                                                                                <tr>
                                                                                    <td colSpan={6} className="text-center" style={{ padding: "30px" }}>
                                                                                        <i className="fa fa-search" style={{ fontSize: "24px", color: "#ccc", marginBottom: "10px" }}></i>
                                                                                        <p>No records found</p>
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* OUT REASON MODAL */}
                <div
                    className="modal fade hide in"
                    id="out_reason"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog ">
                        <div
                            className="modal-content"
                            style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
                        >
                            <div
                                className="modal-body"
                                style={{ padding: "30px 23px 29px 24px" }}
                            >
                                <h3 style={{ margin: "auto", fontSize: "17px" }}>
                                    Please Select The Reason For To Close The File.No:
                                    {localStorage.getItem("currentfileId")}
                                </h3>
                            </div>
                            <div
                                className="form-group"
                                style={{ width: "74%", margin: "auto" }}
                            >
                                <select
                                    className="custom-select"
                                    name="outreason"
                                    value={this.state.outreason}
                                    onChange={(e) => this.onchangeReason(e)}
                                    required
                                    id="select1"
                                    style={{ marginTop: "8px" }}
                                >
                                    <option value="select">Select Your Reason</option>
                                    <option value="Query Raised">Query Raised</option>
                                    <option value=" Re-Query Raised"> Re-Query Raised</option>
                                    <option value="Hold ">Hold </option>
                                    <option value="Completed">Completed</option>
                                    <option value="Other">Others</option>
                                </select>
                                {this.state.selectVal ? (
                                    <p
                                        style={{
                                            color: "red",
                                            textAlign: "center",
                                            fontSize: "16px",
                                        }}
                                    >
                                        Please Select Your Reason{" "}
                                    </p>
                                ) : null}
                            </div>
                            <div className="modal-footer" style={{ marginTop: "27px" }}>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.isLoading}
                                    onClick={this.outimeGet}
                                    style={{ width: "76px", fontSize: "17px" }}
                                >
                                    {" "}
                                    {this.state.isLoading ? (
                                        <i className="fa fa-spinner fa-spin"></i>
                                    ) : (
                                        "OK"
                                    )}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={this.BacktoFile}
                                    style={{
                                        width: "107px",
                                        fontSize: "14px",
                                        border: "1px solid black",
                                        height: "43px",
                                    }}
                                >
                                    {" "}
                                    Back To File
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* OTHER REASON MODAL */}
                <div
                    className="modal hide fade in"
                    id="another-reason"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog ">
                        <div
                            className="modal-content"
                            style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
                        >
                            <h5 style={{ marginTop: "31px", textAlign: "center" }}>
                                Please Type a Reason To Close The File.No:{" "}
                                {localStorage.getItem("currentfileId")}{" "}
                            </h5>
                            <div
                                className="modal-body"
                                style={{ padding: "30px 23px 29px 24px" }}
                            >
                                <div
                                    className="form-group"
                                    style={{ width: "98%", margin: "auto" }}
                                >
                                    <textarea
                                        className="form-control"
                                        placeholder="Type Your Reason"
                                        name="outreason"
                                        onChange={this.onchange}
                                        rows={4}
                                    />
                                    {this.state.selectVal ? (
                                        <p
                                            style={{
                                                color: "red",
                                                textAlign: "center",
                                                fontSize: "16px",
                                            }}
                                        >
                                            Please Type Your Reason{" "}
                                        </p>
                                    ) : null}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => this.outimeGet()}
                                    style={{ width: "76px", fontSize: "17px" }}
                                    disabled={this.state.isLoading}
                                >
                                    {" "}
                                    {this.state.isLoading ? (
                                        <i className="fa fa-spinner fa-spin"></i>
                                    ) : (
                                        "OK"
                                    )}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={() => this.previousPop()}
                                    style={{
                                        width: "76px",
                                        fontSize: "17px",
                                        border: "1px solid black",
                                    }}
                                >
                                    {" "}
                                    Back
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default VettingAutoMailManagement;